module.exports = __webpack_public_path__ + "media/images/placeholder-news-image-533525f9a863e3bb94818d575808edd5.jpg";